"use client";
import { useState } from "react";
import { Box, Flex, HStack, Icon } from "@chakra-ui/react";
import Image from "next/image";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import Link from "next/link";
import {
  HiArrowLeftCircle,
  HiArrowRightCircle,
} from "@onemind-services-llc/react-icons-ng/hi";
import { Playfair_Display } from "next/font/google";
import { CLIENTS_REVIEW } from "@/views/caseStudies/constants";

const playfairDisplay = Playfair_Display({
  weight: ["400", "700"],
  subsets: ["latin"],
});

const CustomersReview = () => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  const [currentIndex, setCurrentIndex] = useState(0);
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? CLIENTS_REVIEW.CONTENT.length - 1 : prevIndex - 1
    );
  };
  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === CLIENTS_REVIEW.CONTENT.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentItem = CLIENTS_REVIEW.CONTENT[currentIndex];
  return (
    <Flex id="clients-review" gap={"2.5rem"} direction={"column"} pt="100px" mt="-100px">
      <Heading
        as="h3"
        variant={HeadingVariant}
        textAlign={{ base: "left", md: "center" }}
      >
        {CLIENTS_REVIEW.HEADING}
      </Heading>
      <Text
        variant={TextVariant}
        textAlign={{ base: "left", md: "center" }}
        maxW={"750px"}
        alignSelf={"center"}
        color="text.100"
      >
        {CLIENTS_REVIEW.DESCRIPTION}
      </Text>
      <Box borderRadius={"10px"}>
        <Flex direction={{ base: "column", md: "row" }} gap="2%">
          <Box
            display={{ base: "none", md: "block" }}
            flex="0 0 26%"
            backgroundColor="#313A3F"
            borderRadius="20px"
            pt="30px"
          >
            <Flex direction="column" justifyContent="space-between" h="100%">
              <Text variant={"body2"} color="white" pl={6}>
                CUSTOMER STORIES
              </Text>
              <Box py={4} px={4} height="320px">
                <Box position="relative" width="100%" height="100%" borderRadius={"20px"}>
                  <Image
                    src={currentItem.image}
                    alt={currentItem.title}
                    layout="fill"
                    objectFit="cover"
                    style={{ borderRadius: "20px" }}
                  />
                </Box>
              </Box>
            </Flex>
          </Box>
          <Box
            flex="0 0 72%"
            backgroundColor={"#f5f5f5"}
            display={"flex"}
            flexDirection={"column"}
            borderRadius="20px"
            justifyContent={"space-between"}
            py={{ base: "40px", md: "80px" }}
            px={{ base: "14px", md: "50px" }}
            minH={{ base: "320px", md: "400px" }}
          >
            <Heading
              as="h2"
              fontSize={{ base: "32px", md: "42px" }}
              lineHeight={{ base: "35px", md: "55px" }}
              fontWeight={400}
              width={{ base: "100%", md: "90%" }}
              fontFamily={playfairDisplay.style.fontFamily}
            >
              &quot;{currentItem.title}&quot;
            </Heading>
            <Flex justifyContent={"space-between"}>
              <Link
                href={currentItem.slug}
                style={{
                  color: "#021B66",
                  textDecoration: "underline",
                  textUnderlineOffset: "0.5rem",
                  textDecorationThickness: "0.1rem",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                Read Story
              </Link>
              <HStack justifyContent="flex-end" gap="10px">
                <Icon
                  as={HiArrowLeftCircle}
                  aria-label="Previous"
                  boxSize={14}
                  _hover={{ color: "blue.500", cursor: "pointer" }}
                  onClick={handlePrev}
                />
                <Icon
                  as={HiArrowRightCircle}
                  aria-label="Next"
                  boxSize={14}
                  _hover={{ color: "blue.500", cursor: "pointer" }}
                  onClick={handleNext}
                />
              </HStack>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default CustomersReview;
